import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderBottomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_bottom"}/>
}
